export const bondInsurancePropertyTypesRequiringComplement = [
  'APARTAMENTO',
  'KITNET',
  'SOBRADO',
  'FLAT/RESIDENCE SERVICE',
  'COBERTURA',
] as const;

export type BondInsurancePropertyTypeRequiringComplement =
  (typeof bondInsurancePropertyTypesRequiringComplement)[number];

export const bondInsuranceRequiresComplement = (propertyType?: string | null) =>
  !!propertyType &&
  (bondInsurancePropertyTypesRequiringComplement as readonly string[]).includes(
    propertyType,
  );

